/**=========================================================
 * Module: constants.js
 * Define constants to inject across the application
 =========================================================*/
EasingFunctions = {
  // no easing, no acceleration
  linear: function (t) { return t },
  // accelerating from zero velocity
  easeInQuad: function (t) { return t*t },
  // decelerating to zero velocity
  easeOutQuad: function (t) { return t*(2-t) },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function (t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t },
  // accelerating from zero velocity
  easeInCubic: function (t) { return t*t*t },
  // decelerating to zero velocity
  easeOutCubic: function (t) { return (--t)*t*t+1 },
  // acceleration until halfway, then deceleration
  easeInOutCubic: function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 },
  // accelerating from zero velocity
  easeInQuart: function (t) { return t*t*t*t },
  // decelerating to zero velocity
  easeOutQuart: function (t) { return 1-(--t)*t*t*t },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function (t) { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t },
  // accelerating from zero velocity
  easeInQuint: function (t) { return t*t*t*t*t },
  // decelerating to zero velocity
  easeOutQuint: function (t) { return 1+(--t)*t*t*t*t },
  // acceleration until halfway, then deceleration
  easeInOutQuint: function (t) { return t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t }
}
App
  .value('duScrollDuration', 450)
  .value('duScrollEasing', EasingFunctions.easeOutCubic)
  .value('duScrollGreedy', true)
  .value('duScrollOffset', Number(($(window).height() * 0.1).toFixed()))
  .value('duScrollBottomSpy', true)
  .constant('APP_COLORS', {
    'primary': '#00CBE6',
    'success': '#70D486',
    'info': '#00CBE6',
    'warning': '#FFC76A',
    'danger': '#FF7581',
    'inverse': '#464b50',
    'green': '#70D486',
    'purple': '#7F98DE',
    'dark': '#3a3f51',
    'yellow': '#FFC76A',
    'gray-darker': '#464b50',
    'gray-dark': '#858A8E',
    'gray': '#A8ABAE',
    'gray-light': '#C3C5C7',
    'gray-lighter': '#DCDEDF'
  })
  .constant('USER_TYPES', {
    provider_types:['Doctor', 'PhysicianAssistant', 'NursePractitioner','MedicalAssistant','Dentist','Hygienist'],
    staff_types: ['Staff', 'RegisteredNurse']
  })
  .constant('APP_MEDIAQUERY', {
    'desktopLG': 1200,
    'desktop': 992,
    'tablet': 768,
    'mobile': 480
  })
  .constant('APP_REQUIRES', {
    // jQuery based and standalone scriptsapplication/vnd.Nexhealth+json; version=1
    scripts: {
      'modernizr': ['/master/bower_components/modernizr/modernizr.js'],
      'icons': ['/master/bower_components/font-awesome/css/font-awesome.min.css',
        '/master/bower_components/simple-line-icons/css/simple-line-icons.css'
      ],
      'filestyle': ['vendor/bootstrap-filestyle/bootstrap-filestyle.js'],
      'elif': ['/master/bower_components/ng-elif/src/elif.js'],
      // Stripe.js has no file extension, so tell ocLazyLoad it is a script
      'stripe': [{ type: 'js', path: 'https://js.stripe.com/v3/' }]
    },
    // Angular based script (use the right module name)
    modules: [
      {
        // Controllers/directives for the pages still rendered by Angular (master/js/legacy).
        // They register into the already-bootstrapped 'angle' module, which is why `name`
        // is 'angle'; states resolve it via the `key`. Built by gulp scripts:legacy.
        key: 'legacy',
        name: 'angle',
        files: [window.NH_LEGACY_JS || '/app/js/legacy.js']
      },
      {
        name: 'home',
        files: [
          '/app/homepage/js/bootstrap-hover-dropdown.min.js',
          // '/app/homepage/js/back-to-top.js',
          '/app/homepage/js/jquery.placeholder.js',
          '/app/homepage/font-awesome/css/font-awesome.min.css',
          '/app/homepage/js/main.js'
        ],
        serie: true
      },
      {
        name: 'salesforce-chat',
        files: ['/vendor/salesforce/chat.min.js']
      },
      { name: 'fontawesome',
        files: ['/master/bower_components/font-awesome/css/font-awesome.min.css']
      },
      { name: 'fontawesomeold',
        files: ['/vendor/fontawesome/css/font-awesome-old.css']
      },
      {
        name: 'toaster',
        files: ['/vendor/angularjs-toaster/toaster.min.css']
      }, {
        name: 'ngTable',
        files: ['/master/bower_components/ng-table/dist/ng-table.js',
          '/master/bower_components/ng-table/dist/ng-table.min.css'
        ]
      }, {
        name: 'ngSmoothScroll',
        files: ['/master/bower_components/ngSmoothScroll/angular-smooth-scroll.js']
      }, {
        name: 'ngDialog',
        files: ['/master/bower_components/ngDialog/css/ngDialog.min.css',
          '/app/css/ngDialog-theme-default.min.css',
          '/app/css/ngDialog-custom-width.css'
        ]
      }, {
        name: 'schema-form',
        files: [
          '/master/bower_components/tv4/tv4.js',
          '/master/bower_components/objectpath/lib/ObjectPath.js',
          '/master/bower_components/angular-schema-form/dist/schema-form.js',
          '/master/bower_components/angular-schema-form/dist/bootstrap-decorator.js',
          '/master/bower_components/angular-schema-form-dynamic-select/angular-schema-form-dynamic-select.js'
        ],
        serie: true

      }, {
        name: 'ngFader',
        files: [
          '/vendor/ngFader/ngFader.js',
          '/vendor/ngFader/CSS/ngFader.min.css',
        ]
      }, {
        name: 'dirpaginate',
        files: [
          '/master/bower_components/angularUtils-pagination/dirPagination.js'
        ]
      }, {
        name: 'plotly',
        files: [
          '/master/bower_components/plotly.js/dist/plotly.min.js',
          '/master/bower_components/angular-plotly/src/angular-plotly.js'
        ]
      }, {
        name: 'sortable',
        files: [
          '/master/bower_components/angular-ui-sortable/sortable.min.js'
        ]
      }, {
        name: 'xEditable',
        files: [
          '/master/bower_components/angular-xeditable/dist/css/xeditable.css',
          '/master/bower_components/angular-xeditable/dist/js/xeditable.min.js'
        ]
      },
      {
        name: 'showdown',
        files: [
          '/node_modules/showdown/dist/showdown.js'
        ]
      },
      {
        name: 'rangy',
        files: [
          'https://cdnjs.cloudflare.com/ajax/libs/rangy/1.3.0/rangy-core.js'
        ]
      }, {
        name: 'tomarkdown',
        files: [
          '/node_modules/to-markdown/dist/to-markdown.js'
        ]
      }, {
        name: 'hallo',
        files: [
          '/node_modules/hallo/examples/hallo.css',
          '/node_modules/hallo/examples/hallo.js'
        ]
      }, {
        name: 'angular-busy',
        files: [
          '/master/bower_components/angular-busy/dist/angular-busy.css',
          '/master/bower_components/angular-busy/dist/angular-busy.js'
        ]
      }, {
        name: 'angularFileUpload',
        files: [
          '/master/bower_components/angular-file-upload/angular-file-upload.min.js'
        ]
      }, {
        name: 'ladda',
        files: [
          '/master/bower_components/ladda/js/spin.js',
          '/master/bower_components/ladda/js/ladda.js',
          '/master/bower_components/ladda-angular/dist/ladda-angular.js'
        ],
        serie: true
      }, {
        name: 'sweet-alert',
        files: [
          '/master/bower_components/sweetalert/dist/sweetalert.min.js',
          '/master/bower_components/angular-sweetalert/SweetAlert.min.js'
        ]
      }, {
        name: 'ui-select',
        files: [
          '/master/bower_components/angular-ui-select/dist/select.min.js',
          '/master/bower_components/angular-ui-select/dist/select.min.css'
        ]
      }, {
        name: 'angular-strap',
        files: [
          '/master/bower_components/angular-strap/dist/modules/dimensions.min.js',
          '/master/bower_components/angular-strap/dist/modules/parse-options.min.js',
          '/master/bower_components/angular-strap/dist/modules/tooltip.min.js',
          '/master/bower_components/angular-strap/dist/modules/tooltip.tpl.min.js',
          '/master/bower_components/angular-strap/dist/modules/select.min.js',
          '/master/bower_components/angular-strap/dist/modules/select.tpl.min.js'
        ],
        serie: true
      }, {
        name: 'angular-filter',
        files: [
          '/master/bower_components/angular-filter/dist/angular-filter.min.js'
        ]
      }, {
        name: 'datepicker',
        files: [
          '/master/bower_components/bootstrap/js/dropdown.js',
          '/node_modules/angular-bootstrap-datetimepicker/src/js/datetimepicker.js',
          '/node_modules/angular-bootstrap-datetimepicker/src/js/datetimepicker.templates.js',
          '/node_modules/angular-bootstrap-datetimepicker/src/css/datetimepicker.css'
        ],
        serie: true
      }, {
        name: 'datetimeinput',
        files: [
          '/node_modules/angular-date-time-input/src/dateTimeInput.js'
        ],
        serie: true
      }, {
        name: 'daterangepicker',
        files: [
          '/master/bower_components/bootstrap-daterangepicker/daterangepicker.js',
          '/master/bower_components/angular-daterangepicker/js/angular-daterangepicker.min.js',
          '/master/bower_components/bootstrap-daterangepicker/daterangepicker.css'
        ],
        serie: true
      }, {
        name: 'ChartJs',
        files: [
          '/master/bower_components/chart.js/dist/Chart.min.js',
          '/master/bower_components/angular-chart.js/dist/angular-chart.min.js'
        ],
        serie: true
      }, {
        name: 'rzslider',
        files: [
          '/master/bower_components/angularjs-slider/dist/rzslider.js',
          '/master/bower_components/angularjs-slider/dist/rzslider.css'
        ],
        serie: true
      }, {
        name: 'wysiwyg',
        files: [
          '/master/bower_components/ngWYSIWYGfixed/dist/editor.min.css',
          '/master/bower_components/ngWYSIWYGfixed/dist/wysiwyg.min.js'
        ],
        serie: true
      },
      {
        name: 'ui-mention',
        files: [
          '/master/bower_components/angular-ui-mention/dist/mention.min.js'
        ]
      },
      {
        name: 'ui-grid',
        files: [
          '/master/bower_components/angular-ui-grid/ui-grid.min.css',
          '/master/bower_components/angular-ui-grid/ui-grid.min.js'
        ]
      },
      {
        name: 'anular-ui-mask',
        files: [
          '/master/bower_components/angular-ui-mask/dist/mask.min.js'
        ],
        serie: true
      }
    ]

  })
  // .constant('SERVER_BASE_URL', 'http://rails-backend-api-nexhealth.on-aptible.com/')
  // .constant('SERVER_BASE_URL', 'http://54.165.88.135:3000')
  // .constant('SERVER_BASE_URL', 'http://lvh.me:3000')
  .filter('trustUrl', function ($sce) {
    return function(url) {
      return $sce.trustAsResourceUrl(url);
    };
  });

var baseUrl = window.NH_API_BASE
var baseWebappUrl, clientId
if (window.location.hostname.indexOf('nexhealth-webapp.local') != -1) {
  baseWebappUrl = 'http://nexhealth-webapp.local:8080'
  baseAuthUrl = baseUrl
  environment = 'development'
  clientId = 'MFuQ9LZnSHKoJbP78CMs5LGr0ASw43ZlhaogZHOOGXg'
}
else if (match = window.location.hostname.match(/^frontend-([^.]+)\.development\.nexhealth-dev\.com$/i)) {
  id = match[1]
  baseWebappUrl = `https://frontend-${id}.development.nexhealth-dev.com`
  baseAuthUrl = baseUrl
  environment = 'staging'
  clientId = 'MFuQ9LZnSHKoJbP78CMs5LGr0ASw43ZlhaogZHOOGXg'
}
else if (window.location.hostname.indexOf('app.staging.nexhealth-dev.com') != -1){
  baseWebappUrl = 'https://app.staging.nexhealth-dev.com'
  baseAuthUrl = baseUrl
  environment = 'staging'
  clientId = 'MFuQ9LZnSHKoJbP78CMs5LGr0ASw43ZlhaogZHOOGXg'
}
else if (window.location.hostname.indexOf('app.staging.nexhealth.cloud') != -1){
  baseWebappUrl = 'https://app.staging.nexhealth.cloud'
  baseAuthUrl = 'https://auth.staging.nexhealth.cloud'
  environment = 'staging'
  clientId = 'MFuQ9LZnSHKoJbP78CMs5LGr0ASw43ZlhaogZHOOGXg'
}
else if (window.location.hostname.indexOf('nexhealth') != -1){
  baseWebappUrl = 'https://app.nexhealth.com'
  baseAuthUrl = 'https://auth.nexhealth.com'
  environment = 'production'
  clientId = 'eTjm-JWUusmt-l1N3gfaxS_ydWmd4qbeR7UeFeRUWMc'
}
else if (window.location.hostname.indexOf('host.docker.internal') != -1){
  baseWebappUrl = 'http://localhost:8080'
  baseAuthUrl = baseUrl
  environment = 'test'
}
else {
  baseWebappUrl = 'http://localhost:8080'
  baseAuthUrl = baseUrl
  environment = 'development'
  clientId = 'MFuQ9LZnSHKoJbP78CMs5LGr0ASw43ZlhaogZHOOGXg'
}

const chromeExtensionDefaultContent = {
  header: {
    title: 'NexHealth Upgrade',
  },
  body:`
    <p><strong>We're excited to announce the new NexHealth Google Chrome extension, enhancing NexHealth's speed and reliability.</strong></p>
    <p>It only takes a few minutes to upgrade and add our new extension. Click the button below, then "Add to Chrome" on the next page, and confirm you want to add it.</p>
    <p>Over the next two weeks, some of our core functionalities will be powered by our new Chrome Extension. <strong>Be sure to add the upgrade <span class="underline">on all workstations</span>.</strong></p>
    <p>Questions? Call us at (888) 875-0851</p>
  `,
  footer: {
    mainButton: 'Upgrade Now'
  }
}

const chromeExtensionCurveContent = {
  header: {
    title: 'NexHealth Update',
  },
  body:`
    <p><strong>We appreciate all customers for taking action to add our Chrome extension and we are providing an updated version to continually improve our reliability and speed.</strong></p>
    <p>Please ensure you update and add the new version of the Chrome extension to all workstations.</p>
    <p>As always, we are here to help if problems exist so please do not hesitate to reach out by calling (888) 875-0851</p>
  `,
  footer: {
    mainButton: 'Upgrade Now'
  }
}

const chromeExtensionClients = {
  denticon: {
    ids: [
      'cnkfdbbjpjmibklepkenbkgdehfknjbp',
      'ficmcmjbchnjghimeoihplgklghcnica',
      'ildkcdkpimdijlmfhlnkbockpopfeidc',
    ],
    url: 'https://chrome.google.com/webstore/detail/nexhealth-integration/cnkfdbbjpjmibklepkenbkgdehfknjbp?hl=en',
    content: {
      header: {
        title: 'NexHealth Update Required',
      },
      body: `
        <p><strong>NexHealth requires you to use our Chrome Extension to power real-time syncs with your Practice Management System!</strong></p>
        <p>Adding our extension to your browser is critical. It will ensure appointments are never double booked and you can message new patients immediately.</p>
        <p>Click below to open the installation screen a new tab, click "Add to Chrome" when it opens, then confirm you want to add the extension.</p>
        <p><strong>Refresh this page once the extension is installed to continue using NexHealth.</strong></p>
        <p>Questions? Call us at (888) 345-2549</p>
      `,
      footer: {
        mainButton: 'Install Extension',
      },
    },
  },
  curve2: {
    ids: [
      'ijclfekibhpogjnhghglkgfppbnneklb',
      'opekblekcocjbmmokhjikpendfcpclkc',
      'gmiloacdnfjaifekkbpcpbfhkcfpoeni',
    ],
    url: 'https://chrome.google.com/webstore/detail/nexhealth-v2/ijclfekibhpogjnhghglkgfppbnneklb?hl=en',
    content: chromeExtensionCurveContent,
  },
  dentrixascend: {
    ids: [
      'kbifcejomlemoidkanlfnjfdbfljogel',
      'pohcmpljibffceijoiihogfgdllmhomf',
      'jcepbgpjkjjiefalcnfkdigkdhbmgnio',
    ],
    url: 'https://chrome.google.com/webstore/detail/nexhealth-v3/kbifcejomlemoidkanlfnjfdbfljogel?hl=en',
    content: chromeExtensionDefaultContent,
  },
  ecw: {
    ids: [
      'pcbodbfbcdpolpljmomnjokdkamoadea',
      'igekonkhmabpapoaaokidpegnfhjlcdm',
      'fampedhjgpomhplohhngcjplifnacmad',
    ],
    url: 'https://chrome.google.com/webstore/detail/nexhealth-v4/pcbodbfbcdpolpljmomnjokdkamoadea?hl=en',
    content: chromeExtensionDefaultContent,
  },
  athena: {
    ids: [
      'mfbibcilckhologlceechchpgkfcgfld',
      'dlocknpfefiphdedadjbdbodklenihnn',
      'kfddoomekdgpppjkmhoggdhojjfeckdm',
    ],
    url: 'https://chrome.google.com/webstore/detail/nexhealth-synchronizer-v6/dlocknpfefiphdedadjbdbodklenihnn?hl=en',
    content: chromeExtensionDefaultContent,
  },
  cloud9: {
    ids: [
      'kfhklgifagihdcphjfdedeedlammccol',
      'doghjalblaojinifadafhkalphgcbdem',
      'ccgcghfenocipgefgnabdfhnecjohpbi',
    ],
    url: 'https://chrome.google.com/webstore/detail/nexhealth-synchronizer-v7/doghjalblaojinifadafhkalphgcbdem?hl=en',
    content: chromeExtensionDefaultContent,
  },
};

App.constant('SERVER_BASE_URL', baseUrl)
App.constant('SERVER_BASE_AUTH_URL', baseAuthUrl)
App.constant('WEBAPP_BASE_URL', baseWebappUrl)
App.constant('ENVIRONMENT', environment)
App.constant('CHROME_EXTENSION_PMS', chromeExtensionClients)
App.constant('OAUTH_CLIENT_ID', clientId)

App.factory('ordinalService', function () {
    var ordinal = function (input) {
      var n = input % 100;
      return n === 0 ? 'th' : (n < 11 || n > 13) ?
        ['st', 'nd', 'rd', 'th'][Math.min((n - 1) % 10, 3)] : 'th';
    };
    return {
      ordinal: ordinal
    };
  })
  .filter('ordinal', ['ordinalService', function (ordinalService) {
    return function (input) {
      return input + ordinalService.ordinal(input);
    };
  }])
  .filter('underscore_to_space', function() {
    return function(key) {
      if(key){

        return key.replace(/\_/g,' ')
      }
    }
  }).filter('pluralize', function() {

    function pluralize(noun) {
      if (typeof noun !== 'string') { return noun; }

      var rules = [
        {regex: /octopus/gi, suffix: 'octopuses'},
        {regex: /person/gi, suffix: 'people'},
        {regex: /ox/gi, suffix: 'oxen'},
        {regex: /goose/gi, suffix: 'geese'},
        {regex: /mouse/gi, suffix: 'mice'},
        {regex: /bison|buffalo|deer|duck|fish|moose|pike|plankton|salmon|sheep|squid|swine|trout|sheap|equipment|information|rice|money|species|series|news/i, suffix: '$&'}, // bison -> bison
        {regex: /(x|ch|ss|sh)$/gi, suffix: '$1es'}, // dish -> dishes, kiss -> kisses
        {regex: /(hetero|canto|photo|zero|piano|pro|kimono|portico|quarto)$/gi, suffix: '$1s'}, // kimono -> kimonos
        {regex: /(?:([^f])fe|([lr])f)$/, suffix: '$1$2ves'}, // knife -> knives, calf -> calves
        {regex: /o$/gi, suffix: 'oes'}, // hero -> heroes
        {regex: /([^aeiouy]|qu)y$/gi, suffix: '$1ies'}, // cherry -> cherries
        {regex: /s$/gi, suffix: 's'}, // cats -> cats
        {regex: /$/gi, suffix: 's'} // cat -> cats
      ];

      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        if (noun.match(rule.regex)) {
           noun = noun.replace(rule.regex, rule.suffix);
           break;
         }
      }

      return noun;
    }

    return function(input) {
      // if null or undefined pass it through
      return !input ? input : pluralize(input);
    };
  });
